import axios from 'axios'
import qs from 'qs'
import constants from './constants/index'
import {Toast} from 'vant'
import CryptoJS from 'crypto-js'
import _ from 'lodash'


// 加密
function encryptAES(plaintText, key) {
  // var plaintText = plaintText;
  let options = {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  };
  let keyHex = CryptoJS.enc.Utf8.parse(key);
  let encryptedData = CryptoJS.AES.encrypt(plaintText, keyHex, options);
  let encode = encryptedData.toString().replace(/\//g, "_");
  encode = encode.replace(/\+/g, "-");
  return encode;
}

function sha(raw) {
  let sign = CryptoJS.MD5(raw).toString();
  return sign;
}

function encrypt(data) {
  let timestamp = new Date().getTime().toString().padStart(16, '0');
  //let json=JSON.stringify(data);
  let json = qs.stringify(data, {
    serializeDate: (date) => {
      return date.getTime()
      // 用moment处理日期比较方便，自己写格式化方法也可以
      // return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    arrayFormat: 'repeat'
  });
  let encryptData = encryptAES(json, timestamp);
  let raw = `timestamp=${timestamp}&data=${encryptData}`, sign = sha(raw);
  return qs.stringify({
    timestamp,
    "data": encryptData,
    sign
  },{});

}

axios.defaults.timeout = 30000
axios.defaults.withCredentials = true
axios.defaults.baseURL = constants.BASE_URL

// http request 拦截器
axios.interceptors.request.use(function (config = {}) {
  let headers = config.headers || {}

  config.headers = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
    ...headers
  }
  // config.data = qs.stringify(config.data);
  if (false&&config.responseType !== 'blob' && config.headers['Content-Type'] !== 'multipart/form-data') {
    config.data = qs.stringify(config.data, {
      serializeDate: (date) => {
        return date.getTime()
      },
      arrayFormat: 'repeat'
    })
  }

    if (!config.forbidEncrypt) {
      let rs = {}
      //console.log(_.cloneDeep(config))
      //传递的参数都进行加密
      if (!_.isEmpty(config.data)) {
        rs = encrypt(config.data,)
        config.data = rs
        //console.log(config)
      }
    }

  config = {loading: true, quiet: false, ...config}
  if (config.loading) {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
    });
  }

  return config
},
function (err) {
  return Promise.reject(err)
}
)

// http response 拦截器
axios.interceptors.response.use(function (response) {
  let res = response.data, config = response.config
  if (config.loading) {
    Toast.clear();
  }

  // 未登录，或没有权限
  if (res.code === 40001 || res.code === 40002) {
    window.location.href = constants.PREFIX + 'login';
  }

  if (!config.file && !res.success) {
    return Promise.reject(response)
  }
  return response
}, function (err) {
  let config = err.config
  if (config.loading) {
    Toast.clear();
  }
  return Promise.reject(err)
})

/**
 * post 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post (url, data = {}, config = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, config).then(
      response => {
        resolve(response.data)
      }
    ).catch(err => {
      let result = err.data || {}
      if (result === null || !result.message) {
        result = {
          success: false,
          code: 500,
          message: '系统错误'
        }
      }
      if (result.fieldErrors) {
        if (err.config.form) {
          let form = err.config.form, fieldErrors = result.fieldErrors
          for (let key in fieldErrors) {
            let field = form.fields.filter(field => field.prop === key)[0]
            if (field) {
              field.validateState = 'error'
              field.validateMessage = fieldErrors[key]
            }
          }
        }
      }

      if (!err.config.quiet) {
        this.$notify({ type: 'danger', message: result.message });
      } else {
        reject(result)
      }
    })
  })
}

/**
 * 下载文件
 * @param url
 * @param params
 * @returns {Promise}
 */
// export function fetchFile (url, fileName = 'hf.xls', data = {}, config = {}) {
//   config = app.$hf.merge(config, {file: true, responseType: 'blob'})
//
//   return post(url, data, config).then(data => {
//     var a = document.createElement('a')
//     var url = window.URL.createObjectURL(data)
//     a.href = url
//     a.download = fileName
//     a.click()
//     window.URL.revokeObjectURL(url)
//   })
// }



// WEBPACK FOOTER //
// ./src/utils/http.js